import React from 'react';
import BaseContainer from "../containers/common/BaseContainer";
import SurveyForm from "../containers/SurveyForm";


const SurveyPage = ({isTmpCont}) => {

    return (
        <>
            <BaseContainer isTmpCont={isTmpCont} sidebar={true}>
                <SurveyForm />
            </BaseContainer>
        </>
    )
};

export default SurveyPage;
